import { forwardRef } from 'react';
import { Chip, type ChipMenuTrigger } from '../Chip';
import { CitiboxLogo } from '../CitiboxLogo';
import { Stack } from '../Stack';

export interface BrandLockupProps {
  // The market indicator text («Soporte ES»), resolved by the host.
  label: string;
  // The market could not be resolved reliably.
  degraded: boolean;
  // Turns the market pill into the button that opens a menu; the mark stays outside it.
  selector?: ChipMenuTrigger;
}

// The Citibox mark beside the market the deployment points at. A composition of façades (no MUI
// import), shared by every chrome that wears the brand. forwardRef: a menu anchors to the pill.
export const BrandLockup = forwardRef<HTMLElement, BrandLockupProps>(function BrandLockup(
  { label, degraded, selector },
  ref,
) {
  return (
    <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
      <CitiboxLogo />
      {/* A hairline capsule on white chrome while the market reads clean; the degraded state keeps
          the filled warning, because that chip exists to be read before anything else on the
          screen. One size either way, so the header never jumps between the two. */}
      <Chip
        ref={ref}
        label={label}
        color={degraded ? 'warning' : 'default'}
        variant={degraded ? 'filled' : 'outlined'}
        size="medium"
        {...(selector ? { menuTrigger: selector } : {})}
      />
    </Stack>
  );
});
